import { render, staticRenderFns } from "./report-popup.vue?vue&type=template&id=044ecafe&"
import script from "./report-popup.vue?vue&type=script&lang=js&"
export * from "./report-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports